import axios from 'axios'
export default {
  getCards: (page = 1, filters = {}) => axios.get(`/cards`, { params: { page: page, ...filters } }),
  putActivateCard: (id, passcode) => axios.put(`/cards/${id}/activate`, { passcode: passcode }),
  putFreezeCard: (id, passcode) => axios.put(`/cards/${id}/freeze`, { passcode: passcode }),
  putCancelCard: (id, passcode) => axios.put(`/cards/${id}/cancel`, { passcode: passcode }),
  postPhysicalCardSuperadmin: (cardData) => axios.post('/cards/physical_card', cardData)

}
